import React from 'react';
import { VideoType } from '../../../commonTypes/video';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { StyledResponsiveVideo } from './styles';

export type VideoProps = VideoType & ComponentProps;

const ResponsiveVideo: React.FC<VideoProps> = ({
  src,
  screenReaderText,
  videoCookiePolicyData,
  ...props
}) => {
  return (
    <StyledResponsiveVideo
      {...componentProps(props)}
      src={src}
      screenReaderText={screenReaderText}
      videoCookiePolicyData={videoCookiePolicyData}
    />
  );
};

export default applyComponentTheme(ResponsiveVideo, 'ResponsiveVideo');
